module.exports = __webpack_public_path__ + "static/media/status_active.c2708052.svg";